import { openDB } from 'idb';

const dbPromise = openDB('bingo-image-cache', 1, {
  upgrade(db) {
    if (!db.objectStoreNames.contains('images')) {
      db.createObjectStore('images');
    }
  },
});

export default dbPromise;
